"use strict";

exports.__esModule = true;
exports.StyledLoadingDots = exports.LoadingDotsWrapper = exports.Dot3 = exports.Dot2 = exports.Dot1 = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const loadingDotBounceDelay = (0, _styledComponents.keyframes)`
    0%, 80%, 100% { 
        transform: scale(0);
    } 40% { 
        transform: scale(1.0);
    }
`;
const StyledLoadingDots = _styledComponents.default.div`
    display: block;
    text-align: center;
`;
exports.StyledLoadingDots = StyledLoadingDots;
const LoadingDotsWrapper = _styledComponents.default.div`
    position: relative;
    display: block;
    text-align: center;
    height: 20px;
    margin-top: -22px;
    margin-bottom: 0;
`;
exports.LoadingDotsWrapper = LoadingDotsWrapper;
const Dot = _styledComponents.default.div`
    width: 12px;
    height: 12px;
    margin: 16px 3px 0 3px;
    background-color: ${props => props.color ? props.color : props.theme.colors.loadingDots.dotColor};
    border-radius: 50%;
    display: inline-block;
`;
const Dot1 = (0, _styledComponents.default)(Dot)`
    animation: ${loadingDotBounceDelay} 1s infinite ease-in-out both;
    animation-delay: -0.3s;
`;
exports.Dot1 = Dot1;
const Dot2 = (0, _styledComponents.default)(Dot)`
    animation: ${loadingDotBounceDelay} 1s infinite ease-in-out both;
    animation-delay: -0.15s;
`;
exports.Dot2 = Dot2;
const Dot3 = (0, _styledComponents.default)(Dot)`
    animation: ${loadingDotBounceDelay} 1s infinite ease-in-out both;
`;
exports.Dot3 = Dot3;